import { useNotificationsStore } from "./notifications.store";

export function useNotifications() {
  const toggleOpen = useNotificationsStore((s) => s.toggleOpen);
  const isOpen = useNotificationsStore((s) => s.open);
  const setOpen = useNotificationsStore((s) => s.setOpen);
  const unreadMessages = useNotificationsStore(
    (s) => s.unreadMessagesCount
  );

  return {
    isOpen,
    unreadMessages,
    toggleOpen,
    setOpen,
  };
}
